class Header {
  constructor() {
    this.header = document.querySelector('.header');
    this.topHeader = document.querySelector('.top-header');

    if (!this.header || !this.topHeader) {
      return;
    }

    const stickyHeader = () => {
      window.pageYOffset > this.topHeader.offsetHeight
        ? this.header.classList.add('sticky')
        : this.header.classList.remove('sticky');
    };

    if (this.header.classList.contains('header--sticky')) {
      stickyHeader();
      window.addEventListener('scroll', stickyHeader.bind(this));
    }
  }
}
export default Header;
